import { useCallback, useContext, useMemo } from "react";
import { AuthContext } from "../services/auth/auth-context";
import { ISecurityProfile } from "../types/auth";
import { UserRoleType } from "../types/constants";

const toArray = (role: UserRoleType | UserRoleType[]) => {
    return Array.isArray(role) ? role : [role];
}

const useAuth = () => {
    const securityProfile: ISecurityProfile = useContext(AuthContext);

    const hasRole = useCallback(
        (role: UserRoleType | UserRoleType[]) =>
            toArray(role).some((role: UserRoleType) => securityProfile.roles.includes(role)
    ), [securityProfile])

    const isAdmin = hasRole(UserRoleType.ADMINISTRATOR)

    const isRestAdmin = hasRole(UserRoleType.RESTADMIN)

    const isCoordinator = hasRole(UserRoleType.COORDINATOR)

    const isFrenchTranslator = hasRole(UserRoleType.FRENCHTRANSLATOR)

    const isRestAdminOnly = isRestAdmin && !isAdmin && !isCoordinator && !isFrenchTranslator

    return { hasRole, isAdmin, isRestAdmin, isCoordinator, isFrenchTranslator, isRestAdminOnly}
}

export default useAuth
